module.exports = __webpack_public_path__ + "img/image_ad_empty.100e8751.png";